module.exports = __webpack_public_path__ + "static/media/chiefAccountant-2.1c949b69.png";